import React from 'react'
import { shortAboutData } from './data'
import styles from './style.module.scss'
import { Container } from '@shared/components/container'

export const ShortAbout = () => {
	return (
		<Container>
			<div className={styles.wrapper}>
				<h2 className={styles.title}>{shortAboutData.title}</h2>
				<div className={styles.description}>
					{shortAboutData.description.map((text, index) => (
						<p key={index} className={styles.descriptionText}>
							{text}
						</p>
					))}
				</div>
				<div className={styles.sections}>
					{shortAboutData.sections.map((section, index) => (
						<div key={index}>
							<h3 className={styles.sectionTitle}>{section.title}</h3>
							<p className={styles.sectionContent}>{section.content}</p>
						</div>
					))}
				</div>
			</div>
		</Container>
	)
}
